import StarSolid from '@components/Icons/StarSolid.jsx'
import StarHalf from '@components/Icons/StarHalf.jsx'

import { splitLastOccurrence } from '@utils/utils.js'

const ReviewStars = ({ rating }) => {
    if (rating === 5 || rating === '5' || rating === '5.0') {
        rating = '5.0'
    }

    const [ratingBase, ratingDecimal] = splitLastOccurrence(rating, '.')

    const ratingBaseInt = parseInt(ratingBase)

    let ratingDecimalString = '0.' + ratingDecimal

    let ratingDecimalFloat = parseFloat(ratingDecimalString)

    const decimalToPercentage = (decimal) => {
        return decimal * 100
    }
    const percentage = decimalToPercentage(ratingDecimalFloat)
    return (
        <div className="rating-stars flex items-center my-1">
            {ratingBaseInt > 0 &&
                Array(ratingBaseInt)
                    .fill(1)
                    .map((el, i) => {
                        //
                        return <StarSolid key={i} width="w-[12px]" />
                    })}
            {ratingDecimal > 0 ? (
                <StarHalf
                    key="star-5"
                    width="w-[17px]"
                    decimal={ratingDecimalFloat}
                />
            ) : null}
            {rating && rating > 0 ? (
                <span className="ratings-number text-xs">({rating})</span>
            ) : null}
        </div>
    )
}
export default ReviewStars
